module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="result-box alpentraum hidden" data-id="'+
((__t=( result.id ))==null?'':__t)+
'">\n	<div class="inner">\n		\n		';
 var item = result.classes[0] 
__p+='\n\n		<div class="row1">\n\n			<div class="image" style="background-image: url(https://'+
((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
''+
((__t=( item.image ))==null?'':__t)+
')"></div>\n		\n			';
 if ( item.price ) {  
__p+='\n			<div class="price" title="';
 if ( item.inkl ) print("inkl. " + item.inkl + ", ") 
__p+=' '+
((__t=( __('add_spa_tax') ))==null?'':__t)+
'">\n				';
 if ( result.booking == 1 ) { 
__p+='<span class="booking">'+
((__t=( __("result_book_online") ))==null?'':__t)+
'</span>';
 } 
__p+='\n				<span class="digits">'+
((__t=( Math.round( parseFloat(item.price) )  ))==null?'':__t)+
'</span>\n				<span class="currency">€</span>\n			</div>\n			';
 } 
__p+='\n\n		</div>\n\n		<div class="row2">\n\n			';
 if ( favorited ) { 
__p+='\n			<div class="favable on" data-item="clients-'+
((__t=( result.id ))==null?'':__t)+
'" title="'+
((__t=( __('unlike') ))==null?'':__t)+
'"></div>\n			';
 } else { 
__p+='\n			<div class="favable" data-item="clients-'+
((__t=( result.id ))==null?'':__t)+
'" title="'+
((__t=( __('like') ))==null?'':__t)+
'"></div>\n			';
 } 
__p+='\n\n			<div class="col col1">\n				<div class="haus">'+
((__t=( result.name ))==null?'':__t)+
'</div>\n				<h2 class="name"><a href="'+
((__t=( registry('PartnerBase') ))==null?'':__t)+
''+
((__t=( result.shortcut ))==null?'':__t)+
'.html">'+
((__t=( item.name ))==null?'':__t)+
'</a></h2>\n				<div class="info">'+
((__t=( item.facts ))==null?'':__t)+
'</div>\n			</div>\n\n			<div class="col col2">	\n				\n				<div class="location">\n					'+
((__t=( result.street ))==null?'':__t)+
' <br />\n					'+
((__t=( result.plz ))==null?'':__t)+
' '+
((__t=( result.ort ))==null?'':__t)+
' ';
 if ( result.district ) { 
__p+=' / ';
 } 
__p+=' '+
((__t=( result.district ))==null?'':__t)+
'\n				</div>\n\n				';
 if ( hasTag(result, 1990) ) { 
__p+='<div class="fact">'+
((__t=( tagName(1990) ))==null?'':__t)+
'</div>';
 } // Bergbahnen inklusive 
__p+='\n				';
 if ( hasTag(result, 37603) ) { 
__p+='<div class="fact">'+
((__t=( tagName(37603) ))==null?'':__t)+
'</div>';
 } // Hörnerbahnen inklusive 
__p+='\n				';
 if ( hasTag(result, 24268) ) { 
__p+='<div class="fact">'+
((__t=( tagName(24268) ))==null?'':__t)+
'</div>';
 } // Skipass SKI OK 
__p+='\n				';
 if ( hasTag(result, 37601) ) { 
__p+='<div class="fact">'+
((__t=( tagName(37601) ))==null?'':__t)+
'</div>';
 } // Heiß auf Weiß 
__p+='\n\n\n				';
 if ( result.rating > 0 ) { 
__p+='<div class="fact">'+
((__t=( Math.round( result.rating ) ))==null?'':__t)+
'%&nbsp;'+
((__t=( __('result_recommentation') ))==null?'':__t)+
'</div>';
 } 
__p+='\n				';
 if ( item.stars ) { 
__p+='<div class="fact">'+
((__t=( __("result_validated") ))==null?'':__t)+
'&nbsp; '+
((__t=( item.stars.replace(" ","&nbsp;") ))==null?'':__t)+
'</div>';
 } 
__p+='\n\n			</div>\n			<div class="clear"></div>\n		</div>\n	</div>\n</section>\n\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/engine/result-template-alpentraum.html
// module id = 79
// module chunks = 0